import classNames from 'classnames';
import React, { useMemo } from 'react';
import type { Merge } from 'types/utility';
import styles from './DropdownList.module.scss';

interface OwnProps {
  children?: React.ReactNode;
  minWidth?: number;
  noFill?: boolean;
  padding?: number;
}

export type DropdownListProps = Merge<React.HTMLProps<HTMLUListElement>, OwnProps>;

const DropdownList: React.FC<DropdownListProps> = props => {
  const { children, style, padding = 8, className, minWidth, noFill, ...rest } = props;
  const computedStyle = useMemo(
    () => ({ ...style, minWidth, padding }),
    [minWidth, padding, style]
  );
  return (
    <ul
      style={computedStyle}
      className={classNames(styles.container, className, {
        [styles.noFill]: noFill,
      })}
      {...rest}
    >
      {children}
    </ul>
  );
};

export default DropdownList;
